import * as Yup from "yup";

import {
  CarProductIntroFormValues,
  VehicleInputType,
} from "./FormElements/interfaces";

import { useTexts } from "Components/TextContext";
import { WarrantyType } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseVehicleProduct";
import { licensePlateSchema } from "Validation/licensePlateValidation";

export const validationSchema = (
  getText: ReturnType<typeof useTexts>["getText"],
): Yup.ObjectSchema<Partial<CarProductIntroFormValues>> => {
  return Yup.object({
    vehicleInputType: Yup.mixed<VehicleInputType>(),
    toggleVehicleInputType: Yup.boolean().optional(),
    licensePlateNumberSelected: Yup.string(),

    licensePlateNumberSearch: Yup.string().when(["vehicleInputType"], {
      is: (vehicleInputType: VehicleInputType) =>
        vehicleInputType === VehicleInputType.LICENSE_PLATE,
      then: (schema) => schema.concat(licensePlateSchema()),
    }),
    licensePlateNumber: Yup.string().when("vehicleInputType", {
      is: VehicleInputType.LICENSE_PLATE,
      then: (schema) => schema.required(),
    }),

    year: Yup.string().required(
      getText("carform.validation.registration_year-required"),
    ),
    brand: Yup.string().required(getText("carform.validation.brand-required")),
    model: Yup.string().required(getText("carform.validation.model-required")),
    modelType: Yup.string().when("vehicleInputType", {
      is: (type: VehicleInputType) =>
        type === VehicleInputType.MANUAL ||
        type === VehicleInputType.LICENSE_PLATE,
      then: (schema) =>
        schema.required(getText("carform.validation.model_type-required")),
    }),
    modelTypeName: Yup.string(),

    kw: Yup.number().required(),
    configurationId: Yup.number().required(),
    volume: Yup.number().required(),
    canBeBoughtOnline: Yup.boolean()
      .required()
      .test(
        "insurance disabled for target",
        "Insurance can't be bought online",
        (value) => value === true,
      ),
    warrantyType: Yup.mixed<WarrantyType>().when("vehicleInputType", {
      is: VehicleInputType.MANUAL,
      otherwise: (schema) =>
        schema.oneOf(Object.values(WarrantyType)).required(),
    }),

    tfaCode: Yup.string().required(),

    isAlreadyInsured: Yup.boolean(),
  }).defined();
};
